var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-group',{staticClass:"mt-4",attrs:{"columns":""}},_vm._l((_vm.semesters),function(semester,idx){return _c('SemesterCard',{key:idx,attrs:{"semester":semester}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }